import { render, staticRenderFns } from "./ChineseTasks.vue?vue&type=template&id=efc3c204&scoped=true&"
import script from "./ChineseTasks.vue?vue&type=script&lang=js&"
export * from "./ChineseTasks.vue?vue&type=script&lang=js&"
import style0 from "./ChineseTasks.vue?vue&type=style&index=0&id=efc3c204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc3c204",
  null
  
)

export default component.exports